var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.toastData)?_c('div',{staticClass:"toast-wrapper"},[_c('p',{staticClass:"toast-inner"},[_vm._v(" "+_vm._s(_vm.toastData.text)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }